module.exports = __webpack_public_path__ + "img/help.caaec552.svg";